import { render } from "./WatchVariants.vue?vue&type=template&id=07bb16ef"
import script from "./WatchVariants.vue?vue&type=script&lang=js"
export * from "./WatchVariants.vue?vue&type=script&lang=js"

import "./WatchVariants.vue?vue&type=style&index=0&id=07bb16ef&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__